class ProductFormSticky {
  constructor() {
    this.buttonsElement = null;
    this.placeholder = null;
    this.isSticky = false;
    this.rafId = null;
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {
    // Find the product-form-buttons element
    this.buttonsElement = document.querySelector('.product-form-buttons.spacing-style.product-form-buttons--stacked');
    
    if (!this.buttonsElement) return;

    // Create placeholder to prevent layout shift
    this.placeholder = document.createElement('div');
    this.placeholder.className = 'product-form-buttons-placeholder';
    this.placeholder.style.visibility = 'hidden';
    this.placeholder.style.pointerEvents = 'none';
    
    // Store original position before any sticky state
    this.updateThreshold();
    
    // Use requestAnimationFrame for smooth scroll handling
    this.handleScroll = this.handleScroll.bind(this);
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    
    // Handle resize to update threshold
    window.addEventListener('resize', () => {
      if (!this.isSticky) {
        this.updateThreshold();
      }
    }, { passive: true });
    
    // Initial check
    this.checkScroll();
  }

  updateThreshold() {
    // Get position relative to document
    const rect = this.buttonsElement.getBoundingClientRect();
    this.threshold = rect.top + window.scrollY;
  }

  checkScroll() {
    const scrollY = window.scrollY;
    
    if (!this.isSticky) {
      // Check if we've scrolled past the buttons
      if (scrollY >= this.threshold) {
        this.makeSticky();
      }
    } else {
      // When sticky, check if we've scrolled back up
      // Use placeholder position if it exists, otherwise recalculate
      if (this.placeholder.parentNode) {
        const placeholderRect = this.placeholder.getBoundingClientRect();
        const placeholderTop = placeholderRect.top + window.scrollY;
        if (scrollY < placeholderTop) {
          this.removeSticky();
        }
      } else {
        // Fallback: if no placeholder, check against threshold
        if (scrollY < this.threshold) {
          this.removeSticky();
        }
      }
    }
  }

  handleScroll() {
    // Use requestAnimationFrame to throttle
    if (this.rafId) return;
    
    this.rafId = requestAnimationFrame(() => {
      this.checkScroll();
      this.rafId = null;
    });
  }

  makeSticky() {
    if (this.isSticky) return;
    
    // Get height before making sticky
    const height = this.buttonsElement.offsetHeight;
    
    // Insert placeholder right before the buttons element
    if (!this.placeholder.parentNode) {
      this.buttonsElement.parentNode.insertBefore(this.placeholder, this.buttonsElement);
    }
    
    // Set placeholder height to match buttons height
    this.placeholder.style.height = `${height}px`;
    
    // Add sticky class
    this.buttonsElement.classList.add('product-form-buttons--sticky');
    
    this.isSticky = true;
  }

  removeSticky() {
    if (!this.isSticky) return;
    
    // Remove sticky class first
    this.buttonsElement.classList.remove('product-form-buttons--sticky');
    
    // Remove placeholder
    if (this.placeholder.parentNode) {
      this.placeholder.parentNode.removeChild(this.placeholder);
    }
    
    this.isSticky = false;
    
    // Update threshold after removal for next sticky activation
    requestAnimationFrame(() => {
      this.updateThreshold();
    });
  }
}

// Initialize when script loads
new ProductFormSticky();

